export enum FrageSelbstaendigkeit {
  SELBSTAENDIG = 'selbstaendig',

  BEDINGT = 'bedingt',

  TEILWEISE = 'teilweise',

  UNSELBSTAENDIG = 'unselbstaendig',
}
